import React, { Component } from 'react';
import createPlotlyComponent from 'react-plotly.js/factory';
import backend_url from "../../../../routes/API_URL";
import swal from 'sweetalert';
import axios from 'axios';

const API_URL = backend_url['api_url'];
var Plotly = require('plotly.js');
var Plot = createPlotlyComponent(Plotly);

class ProgressGraph extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      Graph_Data: [],
      InspectionStats: [],
      school_id: props.school_id || window.sessionStorage.getItem("school_id"),
      bearer_auth: window.sessionStorage.getItem('token'),
      loading: true,
      error: null,
      dataSource: null
    };
  }
  
  componentDidMount() {
    this.fetchAllData();
  }
  
  componentDidUpdate(prevProps) {
    if (this.props.school_id !== prevProps.school_id) {
      this.setState({ school_id: this.props.school_id }, () => {
        this.fetchAllData();
      });
    }
  }
  
  fetchAllData() {
    const { school_id, bearer_auth } = this.state;
    
    if (!school_id || school_id === 'undefined' || school_id === 'null' || school_id === '') {
      this.setState({ 
        error: 'Invalid school ID',
        loading: false 
      });
      return;
    }
    
    this.setState({ loading: true, error: null });
    
    // Try to get progress data first
    const endDate = new Date().toISOString().split('T')[0];
    const startDate = new Date(new Date().setFullYear(new Date().getFullYear() - 3)).toISOString().split('T')[0];
    
    Promise.all([
      axios.get(`${API_URL}/progress_report/school/${school_id}?start_date=${startDate}&end_date=${endDate}`, 
        { headers: { "Authorization": `Bearer ${bearer_auth}` } }
      ),
      axios.get(`${API_URL}/school_inspection_stats/${school_id}`, 
        { headers: { "Authorization": `Bearer ${bearer_auth}` } }
      )
    ]).then(([progressResponse, statsResponse]) => {
      console.log('Progress data:', progressResponse.data);
      console.log('Inspection stats:', statsResponse.data);
      
      const progressData = progressResponse.data || [];
      const statsData = statsResponse.data.data || [];
      
      this.setState({
        Graph_Data: progressData,
        InspectionStats: statsData,
        dataSource: progressData.length > 0 ? 'progress' : (statsData.length > 0 ? 'stats' : 'none'),
        loading: false
      });
    }).catch(error => {
      console.error('Error fetching data:', error);
      
      if (error.response?.status === 401) {
        swal({
          title: "",
          text: "Your session has expired. You'll automatically be logged out within seconds.",
          icon: "error",
          timer: 1250
        }).then(() => {
          window.sessionStorage.clear();
          window.location.reload();
        });
      } else {
        this.setState({ 
          error: 'Failed to load data',
          loading: false 
        });
      }
    });
  }
  
  render() {
    const { Graph_Data, InspectionStats, loading, error, dataSource } = this.state;
    
    if (loading) {
      return (
        <div className="text-center p-5">
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
          <p className="mt-2">Loading progress data...</p>
        </div>
      );
    }
    
    if (error) {
      return (
        <div className="text-center p-5">
          <h5 className="text-danger">{error}</h5>
          <p>Unable to load data for this school.</p>
        </div>
      );
    }
    
    // Show inspection stats if no progress data
    if (dataSource === 'stats' && InspectionStats.length > 0) {
      const years = InspectionStats.map(item => item.YEAR).sort();
      const counts = years.map(year => {
        const data = InspectionStats.find(item => item.YEAR === year);
        return parseInt(data.visit_count) || 0;
      });
      
      return (
        <React.Fragment>
       
          
          <div style={{ width: '100%', height: '400px', minHeight: '400px' }}>
            <Plot
              data={[{
                type: 'bar',
                x: years,
                y: counts,
                marker: { color: '#2ecc71' },
                name: 'Inspections'
              }]}
              layout={{
                title: 'SCHOOL INSPECTION HISTORY',
                xaxis: { title: 'YEAR' },
                yaxis: { title: 'NUMBER OF INSPECTIONS' },
                autosize: true,
                height: 400
              }}
              useResizeHandler={true}
              style={{ width: '100%', height: '100%' }}
              config={{ responsive: true, displaylogo: false }}
            />
          </div>
        </React.Fragment>
      );
    }
    
    if (dataSource === 'none' || (!Graph_Data.length && !InspectionStats.length)) {
      return (
        <div className="text-center p-5">
          <h5>No Data Available</h5>
          <p>There is no inspection data available for this school.</p>
        </div>
      );
    }
    
    // Show progress data if available
    if (Graph_Data.length > 0) {
      const years = [...new Set(Graph_Data.map(item => item.DATE))].sort();
      const nesIds = [...new Set(Graph_Data.map(item => item.nes_id))].sort();
      
      const traces = years.map((year, index) => {
        const yearData = Graph_Data.filter(item => item.DATE === year);
        const values = nesIds.map(nesId => {
          const data = yearData.find(item => item.nes_id === nesId);
          return data ? parseFloat(data.level_achieved) || 0 : 0;
        });
        
        return {
          type: 'bar',
          name: year,
          x: nesIds.map(id => `NES ${id}`),
          y: values,
          marker: { color: `hsl(${index * 60}, 70%, 50%)` }
        };
      });
      
      return (
        <div style={{ width: '100%', height: '500px', minHeight: '500px' }}>
          <Plot
            data={traces}
            layout={{
              title: 'SCHOOL PERFORMANCE OVERVIEW',
              xaxis: { title: 'NATIONAL STANDARDS', tickangle: -45 },
              yaxis: { title: 'ACHIEVEMENT LEVEL', range: [0, 4] },
              barmode: 'group',
              autosize: true,
              height: 500
            }}
            useResizeHandler={true}
            style={{ width: '100%', height: '100%' }}
            config={{ responsive: true, displaylogo: false }}
          />
        </div>
      );
    }
    
    return null;
  }
}

export default ProgressGraph;